import axios from 'axios'
import {
  removeSurveyAccessToken,
  storedSurveyAccessTokens,
  surveyAccessConfig
} from '~/utils/surveyAnswerSetAccess'

export const state = {
  SurveyAnswerSets: []
}
export const getters = {
  surveyAnswerSets: (state) => {
    return state.SurveyAnswerSets
  },
  surveyAnswerSetById: (state) => (surveyAnswerSetId) => {
    return state.SurveyAnswerSets.find(surveyAnswerSet => surveyAnswerSet.id === surveyAnswerSetId)
  },
  surveyAnswerSetsByIds: (state) => (surveyAnswerSetIds) => {
    return state.SurveyAnswerSets.filter(surveyAnswerSet => surveyAnswerSetIds.indexOf(surveyAnswerSet.id) > -1)
  }
}

export const mutations = {
  surveyAnswerSets (state, surveyAnswerSets) {
    state.SurveyAnswerSets = surveyAnswerSets
  },
  surveyAnswerSetPatch (state, surveyAnswerSet) {
    const index = state.SurveyAnswerSets.findIndex(item => item.id === surveyAnswerSet.id)
    if (index > -1) {
      state.SurveyAnswerSets.splice(index, 1, surveyAnswerSet)
    } else {
      state.SurveyAnswerSets.push(surveyAnswerSet)
    }
  },
  surveyAnswerSetDelete (state, surveyAnswerSetId) {
    const index = state.SurveyAnswerSets.findIndex(item => item.id === surveyAnswerSetId)
    if (index > -1) {
      state.SurveyAnswerSets.splice(index, 1)
    }
  }
}

export const actions = {
  async surveyAnswerSetById (store, surveyAnswerSetId) {
    const { data } = await axios.get(
      '/api/survey-answer-sets/' + surveyAnswerSetId,
      surveyAccessConfig(surveyAnswerSetId)
    )
    store.commit('surveyAnswerSetPatch', data)
    if (data.survey) {
      store.commit('surveys/surveyPatch', data.survey, { root: true })
    }
    return data
  },
  async surveyAnswerSets (store, params = {}) {
    if (!params.page) {
      params.page = 1
    }
    const { data } = await axios.get('/api/survey-answer-sets', { params: params })
    store.commit('surveyAnswerSets', data.data)
    return data
  },
  async surveyAnswerSetDelete (store, surveyAnswerSetId) {
    await axios.delete('/api/survey-answer-sets/' + surveyAnswerSetId)
    store.commit('surveyAnswerSetDelete', surveyAnswerSetId)
  },
  async surveyAnswerSetPatch (store, payload = {}) {
    const { data } = await axios.patch(
      '/api/survey-answer-sets/' + payload.id,
      payload,
      surveyAccessConfig(payload.id)
    )
    store.commit('surveyAnswerSetPatch', data)
    return data
  },
  async fetchRandomUnansweredQuestion (store, surveyAnswerSetId) {
    const { data } = await axios.get(
      '/api/survey-answer-sets/' + surveyAnswerSetId + '/fetch-random-unanswered-question',
      surveyAccessConfig(surveyAnswerSetId)
    )
    store.commit('surveyQuestions/surveyQuestionPatch', data, { root: true })
    return data
  },
  async processResults (store, surveyAnswerSetId) {
    const { data } = await axios.post(
      '/api/survey-answer-sets/' + surveyAnswerSetId + '/process-results',
      {},
      surveyAccessConfig(surveyAnswerSetId)
    )
    return data
  },
  async fetchResults (store, surveyAnswerSetId) {
    const { data } = await axios.get(
      '/api/survey-answer-sets/' + surveyAnswerSetId + '/results',
      surveyAccessConfig(surveyAnswerSetId)
    )
    return data
  },
  async claimOwnedAnswerSets () {
    const claims = storedSurveyAccessTokens().map(async ({ surveyAnswerSetId }) => {
      try {
        await axios.post(
          '/api/survey-answer-sets/' + surveyAnswerSetId + '/claim',
          {},
          surveyAccessConfig(surveyAnswerSetId)
        )
        removeSurveyAccessToken(surveyAnswerSetId)
      } catch (error) {
        if (error.response && [403, 404].includes(error.response.status)) {
          removeSurveyAccessToken(surveyAnswerSetId)
          return
        }
        throw error
      }
    })

    await Promise.all(claims)
  }
}

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}
